import styles from "./InputTextArea.module.css";

function InputTextArea({ placeholder, value, handleChange, ...props }) {
  
  return (
    <textarea
      className={styles.wrapper}
      rows="5"
      {...props}
      onChange={handleChange}
      placeholder={placeholder}
      defaultValue={value}
    ></textarea>
  );
}

export default InputTextArea;
